/**
 * Image Slider
 */

import Flickity from 'flickity';

const imageSlider = {
    cfg: {
        prevBtn: '.js-prevBtn',
        nextBtn: '.js-nextBtn',
        slider: '.js-imageSlider',
        sliderOptions: {
            cellAlign: 'left',
            contain: true,
            draggable: true,
            friction: 1,
            lazyLoad: 2,
            selectedAttraction: 0.1,
            groupCells: true,
            setGallerySize: true,
            imagesLoaded: true,
            prevNextButtons: false,
            pageDots: true,
            wrapAround: false,
            // watchCSS: true

        }
    },

    initPrevNext(f, slider) {
        // const flkty = f.data('flickity');
        const prevBtn = slider.parentNode.querySelector(this.cfg.prevBtn);
        const nextBtn = slider.parentNode.querySelector(this.cfg.nextBtn);
        // previous
        prevBtn.addEventListener('click', (e) => {
            f.previous();
        });
        // next
        nextBtn.addEventListener('click', (e) => {
            f.next();
        });
        // update buttons on select
        f.on('select', () => {
            if (f.selectedIndex > 0) {
                prevBtn.classList.remove('is-disabled');
            } else {
                prevBtn.classList.add('is-disabled');
            }
            if (f.selectedIndex !== f.cells.length-1) {
                nextBtn.classList.remove('is-disabled');
            } else {
                nextBtn.classList.add('is-disabled');
            }
        });
    },

    init() {
        window.addEventListener('load', () => {
            const sliders = [...document.querySelectorAll(this.cfg.slider)];
            if (sliders) {
                sliders.forEach((slider) => {
                    const flkty = new Flickity(slider, this.cfg.sliderOptions);
                    flkty.resize();
                    // prev.addEventListener('click', flkty.next);
                    this.initPrevNext(flkty, slider);

                    setTimeout(() => {
                        flkty.resize();
                        slider.classList.add('is-ready');
                        // this.initPrevNext(flkty, slider);
                    }, 1000);
                });
            }
        });
    }
};

export default imageSlider;



// WEBPACK FOOTER //
// ./___src/templates/_organisms/imageSlider/_script.js